<template lang="html">
	<entity-page id="page__prices-settings" v-loader-overlay="progress">
		<template slot="header-right">
			<z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
		</template>
		
        <FlexTabs v-bind:tabs="tabs" v-model="activeTab" min />
        <ZModulePropertiesLogs v-if="activeTab === 'tab-logs'" v-bind:module="this.module" v-bind:properties="properties"></ZModulePropertiesLogs>

        <div v-if="form && activeTab === 'tab-settings'" class="page__prices-settings__settings row">
            <toggle-card heading="Стоимость перевозки" visibility class="col-6">
                <z-module-properties-input v-model="form" :properties="props.price" ref="inputs-price" />
            </toggle-card>

            <toggle-card heading="Настройки веса" visibility class="col-6">
                <z-module-properties-input v-model="form" :properties="props.weight" ref="inputs-weight" />
            </toggle-card>

            <toggle-card heading="Наименования услуг" visibility class="col-6">
                <z-module-properties-input v-model="form" :properties="props.servicesName" ref="inputs-servicesName" />
            </toggle-card>

            <toggle-card heading="Хранение груза" visibility class="col-6">
                <z-module-properties-input v-model="form" :properties="props.stroage" ref="inputs-stroage" />
            </toggle-card>
        </div>
	</entity-page>
</template>
<script>
    import FlexTabs from '@/components/FlexTabs';
	import ZInput   from '@/components/ZInput';
	import ZSelect  from '@/components/ZSelect';
	import EntityPage  from '@/components/EntityPage.vue';
	import ToggleCard  from '@/components/ToggleCard';
	import ZIconButton from '@/components/ZIconButton.vue';
	import ZInputAutocomplete     from '@/components/ZInputAutocomplete';
    import ZModulePropertiesLogs  from '@/components/ZModulePropertiesLogs';
    import ZModulePropertiesInput from '@/components/ZModulePropertiesInput'
	export default {
		components: {
            ZInput, ZSelect, ZInputAutocomplete, EntityPage,
            ToggleCard, ZIconButton, ZModulePropertiesLogs,
            FlexTabs, ZModulePropertiesInput
        },
		data() {
			return {
                module: 'cost',
                props: {
                    price: [
                        'calculation_type_coefficient',
                        'default_price_by_weight',
                        'default_price_by_volume',
                        'ttn_markup',
                        'agent_markup'
                    ],
                    weight: [
                        'min_weight',
                        'min_volume'
                    ],
                    servicesName: [
                        'forwarding_from_label',
                        'forwarding_to_label',
                        'oversize_label',
                        'storage_label',
                        'ttn_label'
                    ],
                    stroage: [
                        'freight_storage_type',
                        'freight_storage_price',
                        'freight_storage_free_period',
                        'freight_storage_free_period_forwarding'
                    ]
                },
                form: {},
                activeTab: 'tab-settings',
                tabs: [
                    {name: "tab-settings", label: "Настройки"},
                    {name: "tab-logs",     label: "История"},
                ],
                refs: [
                    'inputs-price',
                    'inputs-weight',
                    'inputs-servicesName',
                    'inputs-stroage'
                ]
            }
		},
		computed: {
            progressKey() {
                return 'load-prices-settings-card';
            },
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj[this.progressKey];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
            properties() {
                const result = [];
                Object.values(this.props).map(item => result.push(...item));

                return result;
            }
		},
		methods: {
			/**
			 * Возвращение пользователя на предидущую страницу
			 */
			back() {
				this.$router.push({name: 'Prices', query: this.$route.query});
			},
			/**
			 * Инициализация компонента
			 */
			init() {
				this.$store.commit('openRightPanel');
                this.getValues();
			},
            getValues() {
                this.$store.commit('showProgressBar', this.progressKey);
                this.$store.dispatch('module/getModuleProperties', { module: this.module }).then(r => {
                    if (!r) return;
                    Object.entries(r)
                        .filter(([key]) => this.properties.includes(key))
                        .map(([key, value]) => {
                            if (!value.value && value.default_value) value.value = value.default_value;
                            this.$set(this.form, key, Object.assign(value))
                        });
                }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
            },
			/**
			 * Сохранение цены
			 */
			save() {
                if (this.progress) return;
                Promise.all(this.refs.map(key => this.$refs[key].validate())).then(valid => {
                    if (!valid.every(i => !!i)) return;
                    this.$store.commit('showProgressBar', this.progressKey);

                    const data = {module: this.module, values: []};

                    Object.entries(this.form)
                        .filter(([key]) => this.properties.includes(key))
                        .map(([key, value]) => data.values.push({
                            module_name:  this.module,
                            prop_code:    key,
                            value:        value.value
                        }))

                    this.$store.dispatch('module/setModulePropertiesValue', data)
                        .then(() => this.init())
                        .finally(() => this.$store.commit('hideProgressBar', this.progressKey));
                });
			},         
		},
        created() {
			this.init();
		}
	}
</script>
<style lang="sass">
    #page__prices-settings
        .page__prices-settings__settings.row
            margin: 0
            .col-6
                margin: 0 5px 10px 5px
                width: calc(50% - 10px)
            
</style>


// WEBPACK FOOTER //
// PricesSettings.vue?33d2d730